import { BehaviorSubject, Observable } from 'rxjs';
import { mergeMap, tap } from 'rxjs/operators';

export class SharedReplayRefresh<T> {

  private data$ = new BehaviorSubject<T>(null as any);

  private lastTime!: number;
  private cacheTimeToLive: number;
  private source$: Observable<T>;

  constructor(source$: Observable<T>, minutesToLive: number) {
    this.source$ = source$;
    this.cacheTimeToLive = minutesToLive * 1000 * 60;
  }

  public getSubscriber(): Observable<T> {
    // TODO check time expiration here and call this.refreshData();
    const timeExpired = this.checkIfTimeIsExpired();
    if (timeExpired) {
      return this.refreshData().pipe(
        mergeMap(() => this.data$.asObservable()),
      );
    }
    return this.data$.asObservable();
  }

  private refreshData() {
    return this.getData().pipe(
      tap({
        next: (data) => {
          this.data$.next(data);
        },
        error: (a) => {
          this.lastTime = new Date(1980, 1, 1).getTime();
        },
      }),
    );
  }

  private getData() {
    return this.source$;
  }

  private checkIfTimeIsExpired() {
    if (!this.lastTime) {
      this.lastTime = new Date().getTime();
      return true;
    }
    if (new Date().getTime() - this.lastTime > this.cacheTimeToLive) {
      this.lastTime = new Date().getTime();
      return true;
    }
    return false;
  }
}
